export default "__VITE_ASSET__pSqNYcF2__"